export enum BetCalculationsEnum {
    TaxOnStake = 'taxedStake',
    TotalOdd = 'totalOdd',
    PossibleWin = 'possibleWin',
    Bonus = 'expressBonus',
    TaxForReturnOrProfit = 'profitOrReturnTax',
    TotalWin = 'totalWin',
    MinPossibleWin = 'minPossibleWin',
    EstimatedReturn = 'estimatedReturn'
}
